import { Icon, Typography } from '@/modules/perseo-billing/ui/react/src';

import type {
  ECencoPayProcessorSubType,
  IPaymentMethodCardPreview
} from '../interfaces';
import { cencoPayCardSubtitle, iconName } from '../interfaces';

const CreditCardPreview = (props: IPaymentMethodCardPreview) => {
  const { paymentMethod, isCencoPay = false, isCencoPayBalance } = props;
  if (!paymentMethod) return null;

  const { cardNumber, paymentTransactionType } = paymentMethod;
  const cardVendorName = paymentMethod?.cardVendorName ?? '';
  const bankCardType = paymentMethod?.bankCardType ?? '';
  const hasCencoPayBalance = isCencoPayBalance ?? false;

  return (
    <div className="co-w-full co-flex co-justify-between co-items-center">
      <div className="co-flex co-flex-col">
        <CreditCardIcon
          isCencoPay={isCencoPay}
          cardVendorName={cardVendorName}
          bankCardType={bankCardType}
          isCencoPayBalance={hasCencoPayBalance}
        />
        {paymentTransactionType ? (
          <Typography
            weight="medium"
            size="body2"
            className="co-text-[#313131]"
          >
            {paymentTransactionType}
          </Typography>
        ) : null}
      </div>
      <div className="co-flex co-flex-col co-justify-between co-items-end">
        {hasCencoPayBalance ? (
          <Typography size="h4" className="co-text-[#313131]">
            Saldo CencoPay
          </Typography>
        ) : cardNumber ? (
          <Typography size="h4" className="co-text-[#313131]">
            **** {cardNumber}
          </Typography>
        ) : null}
      </div>
    </div>
  );
};

type CreditCardIconProps = {
  isCencoPay: boolean;
  cardVendorName: string;
  bankCardType: string;
  isCencoPayBalance: boolean;
  paymentTransactionType?: string;
};

const CreditCardIcon = ({
  isCencoPay,
  cardVendorName,
  bankCardType,
  isCencoPayBalance
}: CreditCardIconProps) => {
  if (isCencoPay) {
    if (isCencoPayBalance) {
      return <CencopayBalanceCardPreview />;
    }
    return (
      <CencoPayCreditCardIconAndSubtitle
        paymentProcessorSubType={bankCardType as ECencoPayProcessorSubType}
      />
    );
  }

  const icon = iconName[cardVendorName as keyof typeof iconName];

  if (cardVendorName && icon) {
    return (
      <div tabIndex={0} aria-label={`${cardVendorName}`} role="img">
        <Icon icon={icon} width={48} height={32} />
      </div>
    );
  }

  return <></>;
};

const CencopayBalanceCardPreview = () => {
  return (
    <div
      className="co-h-[64px] co-rounded-[12px] co-relative co-overflow-hidden co-w-full co-pb-[8px] co-flex"
      tabIndex={0}
    >
      <div className="co-z-10 co-relative co-rounded-t-[11px] co-m-[1px]  co-w-full co-px-4 co-flex">
        <Icon icon="CencoCreditCardBalanceIcon" />
      </div>
    </div>
  );
};

const CencoPayCreditCardIconAndSubtitle = ({
  paymentProcessorSubType
}: {
  paymentProcessorSubType: ECencoPayProcessorSubType;
}) => {
  return (
    <>
      <div tabIndex={0} aria-label={''} role="img">
        <Icon icon="CencopayCard" width={48} height={32} />
      </div>
      <Typography weight="medium" size="body2" className="co-text-[#313131]">
        {cencoPayCardSubtitle[paymentProcessorSubType]}
      </Typography>
    </>
  );
};

export default CreditCardPreview;
